import * as React from "react";
import type { SVGProps } from "react";

const ArrowUpRightOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.3559 10.467V15.1926C15.356 15.3425 15.3266 15.4909 15.2693 15.6294C15.212 15.7679 15.1279 15.8938 15.022 15.9997C14.916 16.1057 14.7901 16.1898 14.6516 16.2471C14.5131 16.3044 14.3647 16.3338 14.2148 16.3337H2.80806C2.65818 16.3338 2.50974 16.3044 2.37124 16.2471C2.23274 16.1898 2.1069 16.1057 2.00092 15.9997C1.89493 15.8938 1.81089 15.7679 1.75359 15.6294C1.69629 15.4909 1.66686 15.3425 1.66699 15.1926V3.78584C1.66686 3.63595 1.69629 3.48752 1.75359 3.34902C1.81089 3.21052 1.89493 3.08468 2.00092 2.97869C2.1069 2.87271 2.23274 2.78867 2.37124 2.73137C2.50974 2.67407 2.65818 2.64464 2.80806 2.64477H7.32344M10.6938 1.66699H16.3337V7.30681M8.61997 9.38068L16.2251 1.77553"
      stroke="#6B7280"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default ArrowUpRightOutlineIcon;

